/* Mini gallery for home cards in the rentals listing */
import 'slick-carousel';

export function mini_gallery_rentals() {
	
	( ( $ ) => {

		if ( $( 'body.page-rv-sites-rentals' ).length <= 0 ) {
			return;
		}

		$( document ).on( 'facetwp-loaded', ( ev ) => {
			$( '.card-rental > .rental--mini-gallery' ).each( ( ind, ele ) => {
				const slider = $( ele );
	
				slider.slick( {
					arrows: true,
					autoplay: false,
					dots: false,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
				} );
			} );
		} );
	

	} )( window.jQuery );
}